import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import { isNewsEntity, isTribeEntity } from '@ipen-portal/ipen-entity-model';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';

export const newsPlugin = createFrontendPlugin({
  extensions: [
    ...makeEntityContentWithToolbar({
      name: 'NewsPage',
      params: {
        filter: isTribeEntity,
        icon: <Icon icon="ph:newspaper-clipping" />,
        loader: () => import('./components/NewsList').then(m => <m.NewsList />),
        path: '/news',
        title: 'News',
        toolbarProps: {
          creationTemplateRef: 'ipen-news',
          disableSorting: true,
        },
        wrapperProps: {
          kindFilter: 'resource',
          typeFilter: 'news',
        },
      },
    }),

    EntityContentBlueprint.make({
      name: 'NewsRedirect',
      params: {
        filter: isNewsEntity,
        loader: async () =>
          import('./components/Redirect').then(m => <m.Redirect />),
        path: '/',
        title: 'Root',
      },
    }),
  ],
  pluginId: 'news',
});
